import { LinkedTaskDialogStateContextProvider } from './LinkedTaskDialogStateContextProvider';
import * as React from 'react';
import { LinkedTasksDialogContentProps, LinkedTasksDialogContent } from './LinkedTasksDialogContent';

export function LinkedTasksDialogWrapper(props: LinkedTasksDialogContentProps) {
  return (
    <LinkedTaskDialogStateContextProvider>
      <LinkedTasksDialogContent {...props}/>
    </LinkedTaskDialogStateContextProvider>
  );
}
